import React from 'react';
import styled from 'styled-components'
import {useField} from "formik";

const Input = (props) => {

    const {type, id, name, label, placeholder, ...rest} = props;
    const [field, meta] = useField(props)

    return (
        <InputWrapper>
            {label && <Label htmlFor={id}>{label}</Label> }
            <InputStyled
                name={name}
                type={type}
                id={id}
                placeholder={placeholder}
                {...field}
                {...rest}>
            </InputStyled>
            { meta.touched && meta.error ? (
                <Error>
                    { meta.error }
                </Error>
            ) : null}

        </InputWrapper>
    );
};

export default Input;

const InputWrapper = styled.div`
    cursor: pointer;
`

const Label = styled.label`
`

const InputStyled = styled.input`
    cursor: pointer;
    width: ${props => props.width ? `${props.width}` : "100%"};
    font-family: ${({theme}) => theme.fonts.sequel45};
    font-size: 1.6rem;
    border: none;
    border-bottom: 1px solid #B8B8B8;
    padding: 2rem 0rem;
    margin-top: 1.2rem;
    outline: none;
    ${({ theme, icon }) => {
        if (icon) {
            return(theme.icons[icon])
        }
    }};
    background-color: transparent;
    background-position: right ${({ theme }) => theme.spacings.medium} center;

    ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: #959595;
    }
    
    :-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: #959595;
    }
    
    ::-ms-input-placeholder { /* Microsoft Edge */
        color: #959595;
    }

    @media ${({theme}) => theme.breakpoints.mobile}{
        width: 100%;
    }
`

const Error = styled.p`
    font-family: Sequel45;
    font-size: 1.6rem;
    color: #DF3B3B;
`
